import {v3} from "../short3.js";

const CylinderStatics = {
    m1: new THREE.Matrix3(),
    v1: v3(),
    diff: v3(),
};

/**
 * Ein Zylinder
 */
export default class Cylinder {

    /**
     * direction must be normalized! 
     */
    constructor (origin=v3(0,0,0), direction=v3(0,1,0),  radius=1, height=1) {
        this.origin = origin;
        this.direction = direction;
        this.radius = radius;
        this.height = height;
        this.resetCache();
    }

    resetCache() {
        this.topCenter_ = null;
        this.bottomHullPoint_ = null;
        this.center_ = null;
        this.sphere_ = null;
        this.line_ = null;
    }

    set(origin, direction, radius, height) {
        this.origin.copy( origin );
        this.direction.copy(direction);
        this.radius = radius;
        this.height = height;
        this.resetCache();
        return this;
    }

    setComponents ( ox, oy, oz, dx, dy, dz, radius, height ) {
        this.origin.set( ox, oy, oz );
        this.direction.set( dx, dy, dz );
        this.radius = radius;
        this.height = height;
        this.resetCache();
        return this;
    }

    setFromLineAndRadius(line,radius) {
        this.origin.copy( line.start );
        this.direction.subVectors( line.end, line.start );
        this.height = this.direction.length();
        this.direction.normalize();
        this.radius = radius;
        this.resetCache();
        return this;
    }

    setFromBottomToTopAndRadius(bottomCenter,topCenter,radius) {
        this.origin.copy( bottomCenter );
        this.direction.subVectors( topCenter, bottomCenter );
        this.height = this.direction.length();
        this.direction.normalize();
        this.radius = radius;
        this.resetCache();
        return this;
    }

    setFromBottomCenterToCenterBottomHullPoint (bottomCenter,topCenter,bottomHullPoint) {
        this.origin.copy( bottomCenter );
        this.direction.subVectors( topCenter, bottomCenter );
        this.height = this.direction.length();
        this.direction.normalize();
        this.radius = bottomCenter.distanceTo( bottomHullPoint );
        this.resetCache();
        return this;
    }

    clone () {
        return new Cylinder(this.origin.clone(),this.direction.clone(),this.radius,this.height);
    }

    copy ( cylinder ) {
        return this.set(cylinder.origin,cylinder.direction,cylinder.radius,cylinder.height);
    }

    bottomCenter() {
        return this.origin;
    }

    topCenter() {
        if (!this.topCenter_) {
            this.topCenter_ = this.direction.clone().multiplyScalar(this.height).add(this.origin);
        }
        return this.topCenter_;
    }

    bottomHullPoint() {
        if (!this.bottomHullPoint_) {
            this.bottomHullPoint_ = Maths3.getAnyOrthonormalVector(this.direction).multiplyScalar(this.radius).add(this.origin);
        }
        return this.bottomHullPoint_;
    }

    center() {
        if (!this.center_) {
            this.center_ = this.direction.clone().multiplyScalar(this.height/2).add(this.origin);
        }
        return this.center_;
    }

    getBoundingSphere() {
        if (!this.sphere_) {
            this.sphere_ = new THREE.Sphere(this.center(), Math.sqrt(this.height*this.height+this.radius*this.radius));
        }
        return this.sphere_;
    }

    getLine() {
        if (!this.line_) {
            this.line_ = new THREE.Line3(this.bottomCenter(), this.topCenter());
        }
        return this.line_;
    }

    setRadius(radius) {
        this.radius = radius;
        this.resetCache();
        return this;
    }

    setHeight(height) {
        this.height = height;
        this.resetCache();
        return this;
    }

    setDirection(direction) {
        this.direction = direction;
        this.resetCache();
        return this;
    }

    setOrigin(origin) {
        this.origin = origin;
        this.resetCache();
        return this;
    }

    applyMatrix4 ( matrix ) {
        this.direction.add( this.origin ).applyMatrix4( matrix );
        this.origin.applyMatrix4( matrix );
        this.direction.sub( this.origin );
        this.direction.normalize();
        const scale = matrix.getMaxScaleOnAxis();
        this.height = this.height * scale;
        this.radius = this.radius * scale;
        this.resetCache();
        return this;
    }

    translate ( offset ) {
        this.origin.add( offset);
        this.resetCache();
        return this;
    }

    equals ( cylinder ) {
        return this.radius==cylinder.radius && this.height==cylinder.height && this.origin.equals( cylinder.origin ) && this.direction.equals( cylinder.direction );
    }

    isIntersectionSphere ( sphere ) {
        const line = this.getLine();

        const sphereCenterToOrigin = CylinderStatics.diff.subVectors( sphere.center, this.origin );
        const directionDistance = sphereCenterToOrigin.dot( this.direction );
        if (directionDistance<-sphere.radius) {
            return false;
        }
        if (directionDistance>this.height+sphere.radius) {
            return false;
        }
        const projection = this.direction.clone().multiplyScalar(directionDistance).add(this.origin);
        const distanceSq = projection.distanceToSquared(sphere.center);
        return distanceSq<=Math.pow(sphere.radius+this.radius,2);
    }

    //distanceToPoint ( point ) {
    //}
    //
    //distanceToSphere ( sphere ) {
    //}
    //
    //isIntersectionLine ( line ) {
    //}
    //
    //intersectLine () {
    //}
}
